import type { AddressData } from 'src/sdk/checkout/data/types/orderformAPI'

import { normalizePostalCode } from '../utils/postalCode'

interface LocalAddressesUpdatePayload {
  updatedAddresses: AddressData[]
  selectedAddressId: string | null
}

export type LocalAddressesPayload = AddressData[] | LocalAddressesUpdatePayload

export function isLocalAddressesArrayPayload(
  payload: LocalAddressesPayload
): payload is AddressData[] {
  return Array.isArray(payload)
}

export function resolveFallbackAddressFromFormPayload(params: {
  updatedAddresses: AddressData[]
  selectedAddressId: string | null
  addingAddress: boolean
  newCep: string
}): AddressData | undefined {
  const { updatedAddresses, selectedAddressId, addingAddress, newCep } = params

  const selectedAddressByPayload = updatedAddresses.find(
    (item) => item.addressId === selectedAddressId
  )

  const selectedAddressByCep = addingAddress
    ? updatedAddresses.find(
        (item) =>
          normalizePostalCode(item?.postalCode) === normalizePostalCode(newCep)
      )
    : undefined

  return (
    selectedAddressByPayload ??
    selectedAddressByCep ??
    updatedAddresses[updatedAddresses.length - 1]
  )
}
